// veed.io share links look like https://www.veed.io/view/{id}?panel=share —
// the embed player lives at the same id under /embed/.
const VEED_VIDEO_ID_PATTERN = /\/view\/([^/?]+)/;

export const getVeedEmbedUrl = (veedUrl: string): string => {
  const videoId = VEED_VIDEO_ID_PATTERN.exec(veedUrl)?.[1];
  if (!videoId) {
    throw new Error(`Unable to extract a veed.io video id from "${veedUrl}"`);
  }
  return `https://www.veed.io/embed/${videoId}`;
};
